import { Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";

function DisplayMessage() {
  return (
    <Grid container justifyContent={"center"} style={{ marginTop: "16px" }}>
      <Typography
        style={{
          color: "#B3B3B3",
          fontStyle: "normal",
          fontWeight: 500,
          fontSize: "12px",
          lineHeight: "12px",
        }}
      >
        ⓘ 평점은 30일 평균 점수입니다.
      </Typography>
    </Grid>
  );
}

export default observer(DisplayMessage);
